import { TabsService } from './components/tabs.service';
import { AfterViewInit, Component, OnInit, ViewEncapsulation,HostListener } from '@angular/core';
import { Router, ActivatedRoute, ActivationEnd, NavigationEnd } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { MenuController, Platform, ToastController, ModalController, LoadingController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Storage } from '@ionic/storage';
import { UserData } from './users/user-data';
import { AuthServiceProvider } from './users/auth-service/auth-service';
import { AgencyDetailsService } from './agency-details/agency-details.service';
import { environment } from '../environments/environment';
import { Subject } from 'rxjs';
import { query } from '@angular/animations';
import { AwardDetailsService } from './award-details/award-details.service';
import { ModalComponent, ModalAlertComponent } from './modal-alert/modal-alert.component';
import { ReportsService } from './reports/reports.service';
import { RolePermissionsService } from './users/rolepermissions-service/rolepermissions-service';
import * as moment from 'moment';
import { UserProfileService } from './users/user-profile';
import { UserProfile } from './users/IUserProfile';
import { UserProfileStorageService } from './services/user-profile-storage.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class AppComponent implements OnInit, AfterViewInit {
  userActivity;

  constructor(
    private menu: MenuController,
    private platform: Platform,
    private router: Router,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private storage: Storage,
    public fundingDetailsService: AwardDetailsService,
    public userData: UserData,
    private toastCtrl: ToastController,
    private authService: AuthServiceProvider,
    private agencyDetailsService: AgencyDetailsService,
    public reportsService: ReportsService,
    private rolePermissionsService: RolePermissionsService,
    public tc: TabsService,
    private activeRoute: ActivatedRoute,
    private modalController: ModalController,
    private menuController: MenuController,
    private loading: LoadingController,
    private userProfileService: UserProfileService,
    private userProfileStorage: UserProfileStorageService
  ) {
    this.setTimeout();
    this.userSet = this.userData;
    console.log('initializeApp() >>>>>>>>>>>>>>>>>>>>>>>>>>>>>.');
    this.initializeApp();
  }

  selectedMenu = '';
  appPages = [
    {
      title: 'Dashboard',
      url: '/dashboard',
      icon: 'briefcase',
      allowedRoles: [4, 5, 6, 8]
    },
    {
      title: 'Funding',
      url: '/funding',
      icon: 'cash',
      allowedRoles: [4, 5, 6, 7, 8]

    },
    {
      title: 'Schools',
      url: '/schools',
      icon: 'school',
      allowedRoles: [4, 5, 6, 7, 8],
    },
    {
      title: 'Students',
      url: '/school-students',
      icon: 'people',
      allowedRoles: [4, 5, 6, 7, 8],
    },
    {
      title: 'Activities',
      url: '/activities',
      icon: 'football',
      allowedRoles: [6],
    },
    {
      title: 'Agencies',
      url: '/agencies',
      icon: 'star',
      allowedRoles: [4, 5],
    },
    {
      title: 'Staff',
      url: '/school-staff',
      icon: 'person',
      allowedRoles: [4, 5, 6, 7, 8],
    },
    {
      title: 'Reports',
      url: '/reports',
      icon: 'document',
      allowedRoles: [4, 5, 6, 7, 8],
    },
    {
      title: 'Admin',
      url: '/master-calendar',
      icon: 'settings',
      allowedRoles: [4, 5],
    }
    // {

  ];
  loggedIn = false;
  dark = false;
  dropdownModel: string;
  agencyName = '';
  currentFiscalYear = '';
  currentCalendarYear: any;
  currentDate: any;
  roles: any;
  roles1to5: any = [1, 2, 3, 4, 5];
  userSet: any;
  sessionTimeout: any = 0;
  pageTabs: any = null;
  // page title
  currentId: any = null;
  unauthorized = false;
  roleName = '';
  separator = '';
  indicator: HTMLIonLoadingElement = null;
  requestsQueue: Array<any> = [];
  menuOpen = true;
  maintenanceFlag=false;
  maintenanceAlert = '';
  maintenanceMsg = '';
  public isBannerVisible: boolean = true;
  userProfile: any;

  ngAfterViewInit() {
    this.initGoogleAnalyticsPageView();
  }

  private initGoogleAnalyticsPageView() {
    this.showLoader();
    const interval = setInterval(() => {
      if ((window as any).ga && (window as any).ga.getAll) {
        this.router.events.subscribe(event => {
          const ga = (window as any).ga;
          if (event instanceof NavigationEnd) {
            const tracker = ga.getAll()[0];
            tracker.set('page', event.urlAfterRedirects);
            tracker.send('pageview');
          }
        });
        clearInterval(interval);
      }
    }, 50);
    this.hideLoader();
  }

  async ngOnInit() {
    this.showLoader();
      
    this.userProfileStorage.initializeProfile().then(() => {       
        this.OnInitLoad();
    });       
  }
  
  OnInitLoad(){
    const self = this;

    // // Initialize the centralized user profile storage
    // try {
    //   await this.userProfileStorage.initializeProfile();
    //   console.log('Centralized user profile storage initialized');
    // } catch (error) {
    //   console.error('Failed to initialize user profile storage:', error);
    // }

    this.userData.isLoggedIn().then((isLogged) => {

      if (isLogged) {
        this.roles = this.userData;
        this.fetchCurrentMasterCalendar();
        this.checkLoginStatus();
        this.listenForLoginEvents();
        this.getDateComponentInfo();
        this.getSettings();
        this.listenForRouterEvents();
      } else {
        console.log('isLogged false case ==========');
        this.router.navigateByUrl('/');
      }
    });
    this.hideLoader();
  }

  fetchCurrentMasterCalendar() {
    this.reportsService.setCurrentMasterCalendar().subscribe((data: any) => {
      console.log('fetchMasterCalendars(): data from calendarYear service:', data);
    });
  }

  listenForRouterEvents() {
    this.router.events.subscribe(e => {
      // console.log(e);
      if (e instanceof ActivationEnd) {
        this.router.events.subscribe(event => {
          if (event instanceof NavigationEnd) {
            (<any>window).ga('set', 'page', event.urlAfterRedirects);
            (<any>window).ga('send', 'pageview');
          }
        });

        //debugger;

        if (e.snapshot.data) {
          this.unauthorized = e.snapshot.data.title === 'Unauthorized';
          const page = this.appPages.find(x => x.title === e.snapshot.data.parent);
          this.selectedMenu = page != null ? page.title : this.selectedMenu;

          if (e.snapshot.data.title) {
            environment.pageTitle = e.snapshot.data.title;
            environment.pageSubTitle = e.snapshot.data.subTitle;
            this.currentId = e.snapshot.params.id;
            console.log(e.snapshot, '~~~~~~~~~~')
          }

          if (e.snapshot.data.tabs) {
            this.pageTabs = e.snapshot.data.tabs;
            //if admin, remove attendance from schools page
            if (this.hasRoles([1, 2, 3, 4, 5]) && e.snapshot.data.parent == 'Schools') {
              this.pageTabs = this.pageTabs.filter(tab => tab.name != 'Attendance')
            }
            // tslint:disable-next-line: prefer-const
            let first = this.pageTabs.find(t => t.selected);
            this.tc.tabChannel = first == null ? this.pageTabs[0].path : first.path;
          } else {
            this.pageTabs = [];
          }
        }
      }
    });
  }

  customRoute(tab) {
    if (tab.customRoute) {
      const route = tab.customRoute.replace('{id}', this.currentId);
      this.router.navigateByUrl(route).then(() => {
        this.tc.tabChannel = tab.path;
      });

    }
  }

  sessionTimeoutObserver() {
    this.router.events.subscribe((routeEvent) => {
      this.sessionTimeout = 0;
    });
    setInterval(() => {
      //debugger;
      console.log(`env timeoute:${environment.sessionTimeout}`);
      console.log(`session timeoute:${this.sessionTimeout}`);
      if (this.sessionTimeout >= environment.sessionTimeout) {
        this.forceLogout(); // sd
      } else {
        this.sessionTimeout = this.sessionTimeout + 30000;
        console.log(`session timeoute:${this.sessionTimeout}`);
      }
    }, 30000);
  }

  setTimeout() {
    this.userActivity = setTimeout(() => this.forceLogout(), environment.sessionTimeout);
  }

  @HostListener('window:mousemove') refreshUserState() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  toggle() {
    this.menuOpen = !this.menuOpen;
  }

  resize(event) {
    if (window.screen.width <= 991) {
      this.menuController.close();
      event.stopPropagation();
    } else {
      if (document.getElementById('resizable-nav').getAttribute('small') === 'false') {
        document.getElementById('resizable-nav').setAttribute('small', 'true');
        document.getElementById('logo').style.cssText = 'display: none; transition: 0.3s;';
        document.getElementById('menu-h').style.cssText = 'position: relative;left: 7px; transition: 0.3s;';
        document.getElementById('main-title').style.cssText = 'padding-inline-start: 0px; padding-inline-end: 0px;transition: 0.3s;';
        document.getElementById('menu-h-title').style.cssText = 'transition: 0.3s;display:none; white-space: pre;';
        document.getElementById('hamburger').style.cssText = 'left: 2px;position: relative;transition: 0.3s;';
        document.getElementById('resizable-nav').style.cssText =
          'min-width: 80px !important; max-width: 80px !important; transition: 0.3s;';
        document.getElementById('agency-text').style.cssText = 'display: none;transition: 0.3s;';
        document.querySelectorAll('ion-menu')[0].querySelectorAll('ion-label').forEach(x => {
          x.style.cssText = 'display:none; transition: 0.3s;';
        });
        document.querySelectorAll('ion-menu')[0].querySelectorAll('ion-icon').forEach(x => {
          x.style.cssText = 'margin-left: 5px; transition: 0.3s;min-width: 43%;';
        });
      } else {
        document.getElementById('resizable-nav').setAttribute('small', 'false');
        document.querySelectorAll('ion-menu')[0].querySelectorAll('ion-icon').forEach(x => {
          x.style.cssText = 'transition: 0.3s;';
        });
        document.querySelectorAll('ion-menu')[0].querySelectorAll('ion-label').forEach(x => {
          x.style.cssText = '';
        });
        document.getElementById('logo').style.cssText = 'transition: 0.3s;';
        document.getElementById('menu-h-title').style.cssText = 'transition: 0.3s;white-space: pre;';
        document.getElementById('hamburger').style.cssText = '';
        document.getElementById('resizable-nav').style.cssText = 'transition: 0.3s;';
        document.getElementById('menu-h').style.cssText = 'transition: 0.3s;white-space: pre;';
        document.getElementById('agency-text').style.cssText = 'transition: 0.3s;';
        document.getElementById('main-title').style.cssText = 'transition: 0.3s;white-space: pre;';
      }
    }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  checkLoginStatus() {
    return this.userData.isLoggedIn().then((loggedIn) => {
      return this.updateLoggedInStatus(loggedIn);
    });
  }

  async updateLoggedInStatus(loggedIn: boolean) {
    setTimeout(() => {
      this.loggedIn = loggedIn;

      this.userProfileService.setUserProfile().subscribe({
        next: (profile) => {
          this.userProfileService.profile$
          .pipe(
            filter((profile): profile is UserProfile => !!profile)
          )
          .subscribe((profile) => {
            this.checkUntilConditionMet();
            this.userProfile = profile;

            console.log('updateLoggedInStatus() >>>>>>>', this.userProfile);

            if (this.userProfile !== null) {
              this.getAgencyName(this.userProfile.agencyId);
              this.getRoleName(this.userProfile.role);
            }
          });
        },
        error: (error) => {
          console.error("Failed to load user profile", error);
        }
      });
    }, 300);
  }

  getAgencyName(agency) {
    console.log('getAgencyName(agency)', agency);
    this.agencyDetailsService.getAgencyDetails(agency).subscribe((data: any) => {
      console.log('getAgencyName(): data from agencyDetailsService:', data);
      this.agencyName = data.name;
    });
  }

  getRoleName(roleid) {
    this.rolePermissionsService.getRoleNameById(roleid).subscribe((data: any) => {
      console.log('getAllRoles(): data from rolePermissionsService:', data);
      this.roleName = data.name;
    });
  }

  async openMenu() {
    await this.menuController.open();
    document.getElementById('resizable-nav').setAttribute('small', 'false');
    document.querySelectorAll('ion-menu')[0].querySelectorAll('ion-icon').forEach(x => {
      x.style.cssText = 'transition: 0.3s;';
    });
    document.querySelectorAll('ion-menu')[0].querySelectorAll('ion-label').forEach(x => {
      x.style.cssText = '';
    });
    document.getElementById('logo').style.cssText = 'transition: 0.3s;';
    document.getElementById('menu-h-title').style.cssText = 'transition: 0.3s;white-space: pre;';
    document.getElementById('hamburger').style.cssText = '';
    document.getElementById('resizable-nav').style.cssText = 'transition: 0.3s;';
    document.getElementById('menu-h').style.cssText = 'transition: 0.3s;white-space: pre;';
    document.getElementById('agency-text').style.cssText = 'transition: 0.3s;';
    document.getElementById('main-title').style.cssText = 'transition: 0.3s;white-space: pre;';
  }

  listenForLoginEvents() {
    console.log('listenForLoginEvents()');
    window.addEventListener('user:login', () => {
      console.log('user:login');
      this.updateLoggedInStatus(true);
      this.userData.getProfile().then((profile: any) => {
        const item = {
          title: 'Funding',
          url: '/awards/',
          icon: 'cash',
          allowedRoles: [6, 7, 8],
        };

        const adminRoles: number[] = [1, 2, 3, 4, 5];

      });
    });

    window.addEventListener('user:signup', () => {
      this.updateLoggedInStatus(true);
    });

    window.addEventListener('user:logout', () => {
      this.updateLoggedInStatus(false);
    });
  }

  async forceLogout() {
    this.userData.logout().then(() => {
      this.authService.signOut();
    });
  }

  async logout() {
    // console.log('logout()', this.dropdownModel);
    if (this.dropdownModel == 'Logout') {
      const options: ModalComponent = {
        header: 'Logout',
        body: 'Are you sure you want to log out?',
        model: { canLogout: true }
      };

      const modal = await this.modalController.create({
        component: ModalAlertComponent,
        componentProps: {
          props: options
        }
      });

      modal.onDidDismiss().then(({ data }) => {
        if (data.model) {
          const { canLogout } = data.model;
          if (canLogout) {
            this.userData.logout().then(() => {
              this.authService.signOut();
            });
          }
        }
        this.dropdownModel = null;
      });
      return await modal.present();
    } else if (this.dropdownModel == 'About Me') {
      const options: ModalComponent = {
        header: 'About Me',
        body: 'Version: ' + environment.appVersion,
        okText: 'Ok',
        messageDialog: true,
        model: {}
      };

      const modal = await this.modalController.create({
        component: ModalAlertComponent,
        componentProps: {
          props: options
        }
      });
      modal.onDidDismiss().then(({ data }) => {
        this.dropdownModel = null;
      });
      return await modal.present();
    } else if (this.dropdownModel == 'User Guide') {
      window.open('https://ihi.gitbook.io/btb-user-guide/', '_blank')
      this.dropdownModel = null;
      window.location.reload();
    }
  }

  getRouteTitle(): string {
    return environment.pageTitle;
  }

  getRouteSubTitle(): string {
    return environment.pageSubTitle;
  }

  getTopNavBarSegments(id) {
    const ids = [
      'activities-segment',
      'students-segment',
      'schools-segment',
      'staff-segment',
      'awards-segment',
    ];
    if (ids.includes(id)) {
      const elToAdd = document.getElementById(id);
      if (elToAdd === undefined) {
        return;
      }
      if (elToAdd.parentElement.id == 'nav') { return; }
      const elToRemove = document.querySelectorAll('#nav ion-segment');
      if (elToRemove.length > 0) {
        elToRemove.forEach((el) => {
          el.remove();
        });
      }
      elToAdd.style.width = '33%';
      elToAdd.style.margin = 'auto';
      elToAdd.style.paddingTop = '20px';
      elToAdd.style.paddingLeft = '10px';
      document.getElementById('nav').appendChild(elToAdd);
    } else {
      const elToRemove = document.querySelectorAll('#nav ion-segment');
      if (elToRemove === undefined) {
        return;
      }
      if (elToRemove.length > 0) {
        elToRemove.forEach(el => {
          el.remove();
        });
      }
    }
  }

  getDateComponentInfo() {
    this.reportsService.getFiscalYears().subscribe((data: any) => {
      console.log('getFiscalYears(): data from getFiscalYears service:', data);
      this.currentFiscalYear = data.filter(x => x.isCurrent)[0].description;
      this.currentFiscalYear = this.currentFiscalYear.slice(0, 2) + ' ' + this.currentFiscalYear.slice(2);
    });
    this.reportsService.getCalendarYears().subscribe((data: any) => {
      console.log('getFiscalYears(): data from getFiscalYears service:', data);
      this.currentCalendarYear = data.filter(x => x.isCurrent)[0].description;
      this.currentCalendarYear = this.currentCalendarYear.slice(0, 2) + ' ' + this.currentCalendarYear.slice(2);
    });
    this.currentDate = moment().format('MMMM Do YYYY');
    this.separator = ',';
  }

  getSettings() {
    this.reportsService.getAllSettings().subscribe((data: any) => {
      var maintenance = data.filter(x => x.isActive && x.settingsType == 'maintenance' && x.appType == 'webapp')
      if (maintenance != null && maintenance != '') {
        this.maintenanceFlag = true;
        this.maintenanceAlert = maintenance[0].title;
        this.maintenanceMsg = maintenance[0].description;
      }
    });
  }

  getTitle() {
    let title = window.location.href.split('/').pop();
    if (!isNaN(Number(title))) {
      const arr = window.location.href.split('/');
      title = arr[arr.length - 2];
      if (!isNaN(Number(title))) {
        title = arr[arr.length - 3];
      }
    }

    switch (title) {
      // Activities
      case 'activities':
        this.getTopNavBarSegments('false');
        return 'Activities';
      case 'activity-details':
        this.getTopNavBarSegments('activities-segment');
        return 'Activities';
      case 'activity':
        this.getTopNavBarSegments('false');
        return 'Activity';
      // Funding
      case 'funding':
        this.getTopNavBarSegments('false');
        return 'Funding';
      case 'dashboard':
        this.getTopNavBarSegments('false');
        return 'Dashboard';
    }
  }

  removeTabOption(route: ActivatedRoute, pathName: string) {
    this.pageTabs = route.snapshot.data.tabs.filter(x => x.path !== pathName);
  }

  showLoader() {
    if (this.indicator == null) {
      this.indicator = {} as HTMLIonLoadingElement;
      if (this.requestsQueue.length == 0) {
        this.loading
          .create({
            message: 'Please wait...',
            duration: 2000,
          })
          .then((res) => {
            this.indicator = res;
            res.present();
          });
      }
    }
  }

  hideLoader() {
    this.requestsQueue.pop();
    if (this.requestsQueue.length == 0) {
      if (this.indicator != null || this.indicator != undefined) {
        if (this.indicator.dismiss) { this.indicator.dismiss(); }
      }
      this.indicator = null;
    }
  }

  openBanner() {
    this.isBannerVisible = true;
  }

  closeBanner() {
    this.isBannerVisible = false;
  }

  async hasRoles(roles: number[]): Promise<boolean> {
    if (!Array.isArray(roles)) {
      return false;
    }

    // Attempt to get the profile if it doesn't exist yet
    if (!this.userProfile) {
      await this.checkUntilConditionMet();
      if (!this.userProfile) {
        this.userProfile = await this.userProfileService.getUserProfile();
      }
    }

    if (this.userProfile) {
      return roles.includes(this.userProfile.role);
    }

    return false;
  }

  async waitForSecond(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async checkUntilConditionMet(): Promise<void> {
    let i = 0;
    while (i < 30 && !this.userProfile) {
      await this.waitForSecond(1000);
      i++;
    }
  }

}
